import { render, staticRenderFns } from "./mobile-noteservice.vue?vue&type=template&id=39c6e630&scoped=true&"
import script from "./mobile-noteservice.vue?vue&type=script&lang=js&"
export * from "./mobile-noteservice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c6e630",
  null
  
)

export default component.exports